import { render, staticRenderFns } from "./DataObjectTable.vue?vue&type=template&id=06876786&scoped=true&"
import script from "./DataObjectTable.vue?vue&type=script&lang=js&"
export * from "./DataObjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06876786",
  null
  
)

export default component.exports